import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '../../../../Form';
import type { CommonProps } from '../CommonProps';
import { type FormOption, getMultilistboxValue } from '../../utils';
import getPropertyTypeOptions from './utils';
import FilterContainer from '../../FilterContainer';
import getListboxContainer from '../getListboxContainer';

type GetPropertyTypesField = {
  searchParams: SearchParams;
  commonProps: CommonProps;
  t: TranslationFunction;
};

const getHasTwoColumns = (commonProps: CommonProps, options: FormOption[]) => {
  if (!commonProps?.isMobile && !commonProps?.isSidebar && !commonProps?.isHorizontal) return true;
  if (commonProps?.isHorizontal && options?.length > 6) return true;
  return false;
};

const getPropertyTypesField = ({ searchParams, commonProps, t }: GetPropertyTypesField): ControlProps => {
  const { dynamicFiltersResponse, isWaiting } = commonProps;
  const accommodationType = dynamicFiltersResponse ? dynamicFiltersResponse.accommodationType : undefined;
  const options = getPropertyTypeOptions({ accommodationType, t, isWaiting });
  const value = getMultilistboxValue(searchParams[URLParameters.ACCOMODATION_TYPE], true);

  return getListboxContainer({
    fieldName: URLParameters.ACCOMODATION_TYPE,
    containerName: FilterContainer.PropertyTypeContainer,
    containerTitle: t('vacation.search.filter.accommodation.type.title'),
    options,
    value,
    fieldClassName: 'property-types-stays',
    ...commonProps,
    hasTwoColumns: getHasTwoColumns(commonProps, options),
  });
};

export default getPropertyTypesField;
